// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'normalize.css'
import App from './App'
import router from './router'
import store from './store'
import VueQuillEditor from 'vue-quill-editor'
import dateUtils from './libs/utils/dateUtils'
import { formatText, formatterMoney } from './libs/utils'
import Pagination from '@/components/Pagination' // for bubble theme
import SDialog from '@/components/SDialog'
import CDialog from '@/components/CDialog'
import XLSX from 'xlsx'

// 导入 Element UI 模块
import ElementUI from 'element-ui'
import SimbartUI from '@/components/SimbartUI'

// 引入样式
// import 'element-ui/lib/theme-chalk/index.css'
import i18n from './langs'
// 导入图标管理
import '@/icons' // icon
// 全局样式
// 引入富文本编辑器样式，创建实例
import '@/styles/index.scss'
import '@/utils/coze-chat'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import { preventReClick } from '../src/libs/utils/preventRepeatClick'

/**
 * 黏贴版
 */
import VueClipBoard from 'vue-clipboard2'

/**
 * 播放器
 */
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

/**
 * font-awesome 图标库
 */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGripVertical } from '@fortawesome/free-solid-svg-icons'
library.add(faGripVertical)

Vue.component('Pagination', Pagination)
Vue.component('SDialog', SDialog)
Vue.component('CDialog', CDialog)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.prototype.dateUtils = dateUtils
Vue.prototype.__formatText = formatText
Vue.prototype.$formatterMoney = formatterMoney

Vue.use(preventReClick)
Vue.use(XLSX)
Vue.use(VueQuillEditor)
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })

Vue.use(SimbartUI, {
  elementConfig: { $mode: 'tight', tightInputWidth: 205 }
})

VueClipBoard.config.autoSetContainer = true
Vue.use(VueClipBoard)
Vue.use(VideoPlayer)

Vue.mixin({
  computed: {
    globalLabelWidthBlock() {
      return this.$i18n.locale === 'zh_CN' ? '80px' : 'auto'
    },
    globalLabelWidth() {
      return this.$i18n.locale === 'zh_CN' ? '90px' : '140px'
      // return this.$i18n.locale === 'zh_CN' ? 'auto' : 'auto'
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js